<template>
  <form>
    <div v-full-height="true">
      <div class="form-group mb-4">
        <label class="form-label">Название <sup class="tx-danger">*</sup></label>
        <input type="text" v-model="model.name" class="form-control">
      </div>
      <div class="form-group mb-4">
        <label class="form-label">ID <sup class="tx-danger">*</sup></label>
        <input type="number" v-model="model.identifier" class="form-control">
      </div>
      <div class="d-flex flex-row align-items-start justify-content-between wd-100p-force mb-4">
        <div class="form-group wd-100p-force">
          <label class="form-label d-flex flex-row align-items-center justify-content-start" >
            <input type="checkbox" v-model="model.actual_bool">
            <div class="fw-500-force mg-rem-l-1" style="display: inline-block; font-size: 0.8rem;" >Актуальный проект</div>
          </label>
        </div>
      </div>

      <div class="form-group mb-4">
        <h5 class="form-label mb-2">Транки</h5>
        <table class="table table-sm mb-2">
          <thead>
            <tr>
              <th>оператор</th>
              <th>транк</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in model.operatorTranks" :key="idx">
              <td>{{ row.operator }}</td>
              <td>{{ row.trank_name }}</td>
              <td class="text-end">
                <a href="javascript:void(0)" @click="removeOpTrank(idx)" class="btn btn-xs btn-link tx-danger" title="удалить">
                  <vue-feather type="x" :size="14" />
                </a>
              </td>
            </tr>
            <tr v-if="!model.operatorTranks || model.operatorTranks.length === 0">
              <td colspan="3" class="tx-12 op-7">Нет связей</td>
            </tr>
          </tbody>
        </table>
        <a href="javascript:void(0)" class="btn btn-sm btn-outline-primary" @click="openAddOpTrank">добавить</a>
      </div>
    </div>
    <div class="d-flex flex-row align-items-center justify-content-between pd-t-30 pd-b-30">
      <a href="javascript:void(0)" :disabled="!saveAllowed || loading" v-on:click="save" class="btn btn-sm btn-outline-success d-flex flex-row align-items-center justify-content-start">
        <vue-feather class="mg-rem-r-1" type="save" :size="14" v-if="!loading"></vue-feather>
        <vue-feather class="mg-rem-r-1" type="loader" :size="14" v-if="loading"></vue-feather>
        Сохранить
      </a>
      <a href="javascript:void(0)" class="btn btn-sm btn-link tx-danger d-flex flex-row align-items-center justify-content-start" v-on:click="remove">
        <vue-feather class="mg-rem-r-1" type="trash" :size="14"></vue-feather>
        Удалить
      </a>
    </div>
  </form>
</template>

<script>
import ProjectsClass from "@/entities/Projects/ProjectsClass";
import VueFeather from "vue-feather";
import ModalCard from "@/elements/ModalCard.vue";
import { h } from "vue";
import OpTrankAdd from "@/entities/Projects/OpTrankAdd.vue";

export default {
  props: { element: { type: Object }},
  components: { VueFeather, ModalCard },
  data() {
    return {
      Projects: null,
      loading: false,
      uploadInProgress: false,

      model: { operatorTranks: [] },
      pre_model: {},
      showAddModal: false,
      addForm: { operator: '', trank_name: '' },
    }
  },
  computed: {
    saveAllowed: {
      get() { return this.Projects ? this.Projects.itemHasBeenChanged() : false; }
    }
  },
  methods: {
    init() {
      this.Projects.item(this.$props.element.id);
    },
    openAddOpTrank() {
      // Use global modal system like other places in the project
      this.emitter.emit(
        'open-global-modal',
        {
          view: h(OpTrankAdd, { onConfirm: (row) => {
            if (!Array.isArray(this.model.operatorTranks)) { this.model.operatorTranks = []; }
            this.model.operatorTranks.push(row);
            this.emitter.emit('close-global-modal-force', {identity: 'add-optrank'});
          }}),
          header: h(ModalCard, {main: 'Добавить связь'}),
          identity: 'add-optrank'
        }
      );
    },
    removeOpTrank(idx) {
      if (!Array.isArray(this.model.operatorTranks)) { return; }
      this.model.operatorTranks.splice(idx, 1);
    },
    save() {
      this.Projects.update(() => {
        this.emitter.emit('add-close-break-point', {identity: 'project-edit-' + this.model.id, closeBreakPoint: false});
        this.init();
      }, () => {
        this.loading = false;
      })
    },
    remove() {
      this.Projects.remove(this.$props.element.id);
    }
  },
  mounted() {
    this.Projects = new ProjectsClass(this);
    this.init();
  }
}
</script>